<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<template lang="pug">

  div

    div.c-auth-page__head
      h1 {{ $t('h1') }}

    //- div(v-if="firstName && lastName") Уважаемый {{firstName}} {{lastName}}, вы успешно зарегистрирвались в Deliver!
    //- div(v-if="email") На ваш email &laquo;{{email}}&raquo; отправлено письмо с инструкциями
    div 
      a(href="https://driver.deliver.ru/bargains") Перейти на платформу Deliver

    div
      .action-button(v-on:click="logout") Выйти
</template>

<script>
import { mapGetters } from 'vuex';

import mFormSubmit from 'mixins/formSubmit';
import * as types from 'store/mutation-types';

export default {
  mixins: [mFormSubmit],

  data() {
    return {
      isLoading: null,
    };
  },

  computed: {
    ...mapGetters('registration', ['email', 'firstName', 'lastName', 'phoneNumberE164']),
  },

  methods: {
    logout() {
      if (this.isLoading) {
        this.warn('Request is already sent');
        return false;
      }

      this.isLoading = true;
      this.errorMessage = false;

      // Проверяем номер телефона
      this.$http
        .get('/logout')
        .then((response) => {
          this.$store.commit(`configuration/${types.UPDATE_IS_AUTHORIZED}`, false);

          this.$router.push({ name: 'enter-number' });
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.error_code) {
            this.errorMessage = error.response.data.error_code;
          } else {
            this.error('Error', error.message);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
